import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { LinkButton } from '@strava/ui/Button';
import { useStravaBranch } from '@strava/container-context';

import styles from './CallToAction.module.scss';

const CallToAction = ({ label, className, dataCy, onClick }) => {
  const { appLink, isProcessing } = useStravaBranch();

  return (
    <LinkButton
      href={appLink}
      variant="primary"
      className={clsx(styles.callToAction, className)}
      data-cy={dataCy}
      onClick={onClick}
      disabled={isProcessing}
    >
      {label}
    </LinkButton>
  );
};

CallToAction.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  onClick: PropTypes.func
};

CallToAction.defaultProps = {
  className: undefined,
  dataCy: undefined,
  onClick: () => {}
};

export default CallToAction;
